import { render } from "./CardToolbar.vue?vue&type=template&id=c623309a"
import script from "./CardToolbar.vue?vue&type=script&lang=js"
export * from "./CardToolbar.vue?vue&type=script&lang=js"
script.render = render

export default script